import styled from '@emotion/styled'

export const ImportedInvoiceDocumentPreviewWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  min-height: 0;
  position: relative;
`
